import { getNamespace } from './storage';

export const bodyReq = (params) => {
    let body = {};
    const existNamespace = Object.keys(params)?.some((item) => item === 'namespace');
    const namespace = getNamespace();
    if (!existNamespace) {
        body = { ...params, namespace };
    } else {
        body = params;
    }
    return body;
};
